export const LIST_AGENT_CREDITS = 20;
